import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { t } from '../../../../../i18n';
import UrlTo from '../../../../../url-to';
import { clockIcon, horseIcon } from '../../../../assets';
import PlayButton from '../../../../components/play-button/index';
import './styles.scss';

const EpisodesList = ({ courseId, isCoursePurchased, episodes, onPlayEpisode, className, history }) => {
  if (episodes.length < 2) {
    return null;
  }

  const handlePlayEpisode = episode => {
    return isCoursePurchased
      ? history.push(UrlTo.coursesWatchLesson(courseId, episode.lessonNumber))
      : onPlayEpisode(episode.previewVideo);
  };

  return (
    <div className={classNames('specific-course-screen__episodes-list', className)}>
      <h1>{t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.EPISODES.TITLE')}</h1>
      {episodes.map((episode, index) => (
        <div key={index} className="specific-course-screen__episodes-list-episode">
          <div className="specific-course-screen__episodes-list-thumbnail" onClick={() => handlePlayEpisode(episode)}>
            <picture>
              <source media="(min-width: 992px)" srcSet={episode.previewImageUrlLarge} />
              <img
                src={episode.previewImageUrlSmall}
                alt={episode.title}
                className="specific-course-screen__episodes-list-thumbnail-image"
              />
            </picture>
            <PlayButton />
          </div>
          <div className="specific-course-screen__episodes-list-info">
            <div className="specific-course-screen__episodes-list-texts">
              <h3>{`${t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.EPISODES.LESSON_TITLE')} ${episode.lessonNumber}`}</h3>
              <h2>{episode.title}</h2>
              <p dangerouslySetInnerHTML={{ __html: episode.description }} />
            </div>
            <div className="specific-course-screen__episodes-list-summary">
              <div className="specific-course-screen__episodes-list-duration">
                <img src={clockIcon} alt="minutes" />
                <span>{`${episode.durationMinutes} ${t('DIGITAL_COURSES.MINUTES')}`}</span>
              </div>
              {episode.materialsCount > 0 && (
                <div className="specific-course-screen__episodes-list-exercises-number">
                  <img src={horseIcon} alt="horse" />
                  <span>{t('DIGITAL_COURSES.EXERCISES', { count: episode.materialsCount })}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default withRouter(EpisodesList);
